import { AuditTemplateDetail } from "./audit-template-details";

export class PrimeNgAuditClassListItem {
    // Prime NgLists bind to label and value so
    // keep these names as label and value
    constructor(public label: string, public value: AuditTemplateDetail) {
    }
}
